import { Link } from "@tanstack/react-router";
import { useState } from "react";
// import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { ReactComponent as ArticlesIcon } from "assets/img/icons/sidebar/articles.svg";
import { ReactComponent as VendorIcon } from "assets/img/icons/sidebar/db.svg";
import { ReactComponent as DigestIcon } from "assets/img/icons/sidebar/digest.svg";
import { ReactComponent as DownIcon } from "assets/img/icons/sidebar/down.svg";
import { ReactComponent as ResourcesIcon } from "assets/img/icons/sidebar/resources.svg";
import { ReactComponent as RssIcon } from "assets/img/icons/sidebar/rss.svg";
import { ReactComponent as SpotlightIcon } from "assets/img/icons/sidebar/spotlight.svg";
import { ReactComponent as UpIcon } from "assets/img/icons/sidebar/up.svg";
import { ReactComponent as DocumentsIcon } from "assets/img/nav-icons/documents.svg";

export const ResourceDropdown = ({ isCollapsed }: { isCollapsed: boolean }) => {
    const [isOpen, setIsOpen] = useState(true);
    const toggleDropdown = () => setIsOpen((prev) => !prev);

    const resources = [
        { to: "/c/blog", name: "Articles", Icon: ArticlesIcon },
        { to: "/vendors", name: "Vendors", Icon: VendorIcon },
        { to: "/rss-feeds", name: "RSS Feeds", Icon: RssIcon },
        { to: "/digest", name: "AI Digest", Icon: DigestIcon, isSub: true },
        { to: "/c/spotlight", name: "Spotlight", Icon: SpotlightIcon, isSub: true },
        // TODO: dedicated Multimedia icon — reusing SpotlightIcon for now
        { to: "/c/multimedia", name: "Multimedia", Icon: SpotlightIcon, isSub: true },
    ];

    return (
        <div>
            <button
                className={`hover:bg-brand-shine flex w-full items-center rounded-lg py-[0.20rem] text-left text-gray-700 focus:outline-none ${
                    isCollapsed ? "justify-center px-0" : "justify-between px-1"
                }`}
                onClick={toggleDropdown}
            >
                <div className={`flex items-center ${isCollapsed ? "" : "space-x-3"}`}>
                    <ResourcesIcon className="h-[32px] w-[32px]" />
                    {!isCollapsed && <span>Resources</span>}
                </div>
                {!isCollapsed && (
                    <span className="">
                        {isOpen ? (
                            <UpIcon className="mr-1 h-[16px] w-[16px]" />
                        ) : (
                            <DownIcon className="mr-1 h-[16px] w-[16px]" />
                        )}
                    </span>
                )}
            </button>
            {isOpen && (
                <ul className={`${isCollapsed ? "ml-0 mt-0" : "ml-0 mt-2"}`}>
                    {resources.map(({ to, name, Icon }) => (
                        <li
                            key={to}
                            className={
                                isCollapsed
                                    ? "relative pl-0 before:content-none after:content-none"
                                    : "relative pl-14 before:absolute before:left-6 before:top-1/2 before:h-[2px] before:w-6 before:-translate-y-1/2 before:-translate-x-[4px] before:rounded-r-none before:bg-[#24a2c1] before:shadow-none before:content-[''] after:absolute after:left-6 after:top-0 after:bottom-0 after:w-[2px] after:-translate-x-[4px] after:rounded-l-none after:bg-[#24a2c1] after:content-[''] last:after:h-1/2 last:after:rounded-bl-lg"
                            }
                        >
                            <Link
                                to={to as "/social"}
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                                className={`hover:bg-brand-shine block rounded-lg py-[0.20rem] text-gray-700 no-underline focus:outline-none focus:ring-0 ${
                                    isCollapsed ? "flex justify-center px-0" : "px-[0.20rem]"
                                }`}
                                activeProps={{
                                    className: "bg-brand-shine",
                                }}
                            >
                                <div
                                    className={`flex items-center ${
                                        isCollapsed ? "justify-center" : "space-x-3"
                                    }`}
                                >
                                    <Icon className="h-[32px] w-[32px]" />
                                    {!isCollapsed && <div>{name}</div>}
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
